/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReportTradeSide = {
    BUY: 'Buy',
    SELL: 'Sell'
} as const;
export type ReportTradeSide = typeof ReportTradeSide[keyof typeof ReportTradeSide];


export function instanceOfReportTradeSide(value: any): boolean {
    for (const key in ReportTradeSide) {
        if (Object.prototype.hasOwnProperty.call(ReportTradeSide, key)) {
            if (ReportTradeSide[key as keyof typeof ReportTradeSide] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReportTradeSideFromJSON(json: any): ReportTradeSide {
    return ReportTradeSideFromJSONTyped(json, false);
}

export function ReportTradeSideFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportTradeSide {
    return json as ReportTradeSide;
}

export function ReportTradeSideToJSON(value?: ReportTradeSide | null): any {
    return value as any;
}

export function ReportTradeSideToJSONTyped(value: any, ignoreDiscriminator: boolean): ReportTradeSide {
    return value as ReportTradeSide;
}

